import React from 'react';
import { 
  Box, 
  Container, 
  Grid, 
  Typography, 
  Button, 
  List, 
  ListItem, 
  ListItemIcon, 
  ListItemText, 
  Divider,
  Paper 
} from '@mui/material';
import { CheckCircleOutline, AccountBalanceWallet, Speed, Assessment, Hub } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';
import PublicLayout from "../../layouts/PublicLayout";

export default function FoodCourt() {
  return (
    <PublicLayout>
      <Box sx={{ bgcolor: '#fff', py: { xs: 8, md: 10 } }}>
        <Container maxWidth="lg">
          <Grid container spacing={8} alignItems="flex-start">
            
            {/* LEFT CONTENT - 60% approx */}
            <Grid item xs={12} md={7}>
              <Typography variant="overline" sx={{ color: '#f6521a', fontWeight: 800, letterSpacing: 1.5 }}>
                TPOS FOR FOOD COURTS & MULTI-VENDOR HUBS
              </Typography>
              
              <Typography variant="h2" sx={{ fontWeight: 600, mt: 1, mb: 2, fontSize: { xs: '1.5rem', md: '2.5rem' }, lineHeight: 1.1 }}>
                Unify Your Food Court Operations Under One <span style={{ color: "#f6521a" }}>Smart Ecosystem.</span>
              </Typography>

              <Typography variant="h6" sx={{ color: 'text.secondary', fontWeight: 500, mb: 4, lineHeight: 1.5 }}>
                Eliminate payment chaos, simplify vendor management, and deliver a frictionless dining experience with TrueMenu’s centralized POS architecture.
              </Typography>

              <Typography variant="body1" sx={{ color: 'text.primary', mb: 5, fontSize: '1.1rem', lineHeight: 1.8 }}>
                Managing a bustling food court is like running a mini-economy. You have multiple independent kitchens, high footfall, and complex revenue-sharing models. 
                <strong> TPOS by TrueMenu</strong> replaces fragmented systems with a unified, centralized payment and management ecosystem. 
                Whether you operate a mall food court, a corporate cafeteria, or an open-air food park, our system ensures smooth prepaid card operations and zero revenue leakage.
              </Typography>

              <Typography variant="h5" sx={{ fontWeight: 700, mb: 3 }}>
                Specialized TPOS Features:
              </Typography>

              <Grid container spacing={3}>
                {[
                  {
                    title: "Vendor Dashboards",
                    desc: "Give brands restricted logins to view their specific sales and inventory analytics.",
                    icon: <Speed sx={{ color: '#f6521a' }} />
                  },
                  { 
                    title: "Centralized Prepaid System", 
                    desc: "Issue NFC-enabled smart cards for lightning-fast tap-to-pay transactions across all stalls.",
                    icon: <AccountBalanceWallet sx={{ color: '#f6521a' }} />
                  },
                  { 
                    title: "Automated Commission Management", 
                    desc: "Auto-deduct rent or percentage commissions before daily settlements are generated.",
                    icon: <Assessment sx={{ color: '#f6521a' }} />
                  },
                  { 
                    title: "Multi-Kitchen Routing (KDS)", 
                    desc: "Instantly split orders from the central desk to specific vendor kitchen screens.",
                    icon: <Hub sx={{ color: '#f6521a' }} />
                  },
                  { 
                    title: "Unified GST & Compliance Reporting", 
                    desc: "Generate consolidated tax reports for the entire premises while maintaining individual GSTIN breakdowns for each registered vendor.",
                    icon: <Hub sx={{ color: '#f6521a' }} />
                  }
                ].map((item, index) => (
                  <Grid item xs={12} sm={6} key={index}>
                    <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2, mb: 2 }}>
                      <Box sx={{ mt: 0.5 }}>{item.icon}</Box>
                      <Box>
                        <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>{item.title}</Typography>
                        <Typography variant="body2" sx={{ color: 'text.secondary' }}>{item.desc}</Typography>
                      </Box>
                    </Box>
                  </Grid>
                ))}
              </Grid>

            </Grid>

            {/* RIGHT IMAGE - 40% approx */}
            <Grid item xs={12} md={5} sx={{ position: 'sticky', top: 100 }}>
              <Paper 
                elevation={0} 
                sx={{ 
                  borderRadius: 4, 
                  overflow: 'hidden', 
                  ground: 'linear-gradient(145deg, #ffffff 0%, #f9f9f9 100%)',
                  p: 2,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: '100%'
                }}
              >
                <Box
                  sx={{
                    width: '100%',
                    height: { xs: 300, md: 550 },
                    borderRadius: 3,
                    overflow: 'hidden',
                    display: 'flex',
                    alignItems: 'right',
                    float:'right'                    
                  }}
                >
                  <img 
                    src="/img/foodcourt.png" 
                    alt="Food Court Management POS" 
                    style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                  />
                </Box>
                
                <Box sx={{ p: 3, width: '100%' }}>
                  <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>Business Impact</Typography>
                  <List dense>
                    <ListItem disableGutters>
                      <ListItemIcon sx={{ minWidth: 35 }}><CheckCircleOutline sx={{ color: '#00ab55', fontSize: 20 }} /></ListItemIcon>
                      <ListItemText primary="Boost transaction speed by 50% with tap-and-go cards." />
                    </ListItem>
                    <ListItem disableGutters>
                      <ListItemIcon sx={{ minWidth: 35 }}><CheckCircleOutline sx={{ color: '#00ab55', fontSize: 20 }} /></ListItemIcon>
                      <ListItemText primary="100% accuracy in vendor payouts and reconciliation." />
                    </ListItem>
                  </List>
                </Box>
              </Paper>
            </Grid>

          </Grid>
        </Container>
      </Box>
    </PublicLayout>
  );
}